/*
 * Default chart payload template for the Demo Environment Management page's
 * "Create payload" editor (entity type: charts). Used internally by
 * `csqCharts.js`'s `createChartWithVersion` as the fallback snapshot/template
 * when the caller doesn't supply its own.
 */

/** Default chart definition template id: "Top devices" (sessions by device). */
export const DEFAULT_TEMPLATE_ID = 'sessions_by_device';

/**
 * Returns a fresh copy of the default chart snapshot ("Top devices" — a bar
 * trend of sessions by device type).
 */
export function defaultSnapshotData(name) {
  return {
    schemaVersion: 1,
    name: name || 'Top devices',
    type: 'Trend',
    variation: 'Bar',
    query: {
      type: 'graph',
      query: {
        main: { fn: 'count_sessions', event: { type: 'session' } },
        dimensions: [{ type: 'field', name: 'device_type', level: 'session' }],
      },
    },
    dateRange: { type: 'relative', count: 30, unit: 'day', step: 'entire_range' },
    description: 'What are the top devices people are using to access my site?',
  };
}
